<template>

	

	<div id="knd-blok4" class="knd-blok">
		<div class="knd-blok-content">
			<div class="knd-blok-titel" v-html='getContent(stap, "Tussenkop")'></div>
			<div class="knd-blok-tekst" v-html='getContent(stap, "Tekst")'></div>

			<video 
				playsinline
				class="knd-blok-video"
				ref="video"
				:src='video'>
					Uw browser ondersteunt het element <code>video</code> niet.
			</video>

			<div class="knd-audio-counter"><Countdown :startdate='"Jan 1, 2000 00:00:00"' :enddate='"Jan 1, 2000 00:00:48"' :play="play"></Countdown></div>

			<img 
				class="knd-blok-afspeelknop" 
				ref="playknop" 
				:src='require("@/assets/images/play.png")' 
				@click="playVideo" />
			<img 
				class="knd-blok-afspeelknop hidden" 
				ref="pauzeknop" 
				:src='require("@/assets/images/pauze.png")' 
				@click="pauseVideo" />
		</div>
	</div>


	<div class="knd-strooigoed-wrapper">
		<img class="knd-strooigoed" :src='require("@/assets/images/tiktok_strooi4.png")' />
	</div>
		
</template>

<script>

import Countdown from './../countdown';

export default {
	name: 'Blok4',
	props: ['stap', 'language', 'mobiel'],
	data() {
		return {
			play: false,
			videos: {
				NL: {
					desktop: require("@/assets/video/NL-DE-WOLF.mp4") + "#t=0.001",
					mobiel: require("@/assets/video/NL-MOB-DE-WOLF.mp4") + "#t=0.001"
				},
				EN: {
					desktop: require("@/assets/video/EN-DE-WOLF.mp4") + "#t=0.001",
					mobiel: require("@/assets/video/EN-MOB-DE-WOLF.mp4") + "#t=0.001"
				}
			},
			video: null

		}
	},
	mounted() {
		this.getVideo();

		window.addEventListener("resize", () => {
			setTimeout(() => {
				this.getVideo();
			}, 2000);
		});
	},
	methods: {
		getContent(content, label) {
			if (this.language === "nl") {
				return content[label].data;
			}
			else {
				return content[label].data5891;	
			}
		},

		getVideo() {
			if (this.mobiel) {
				this.video = this.language === "nl" ? this.videos.NL.mobiel : this.videos.EN.mobiel;
			}
			else {
				this.video = this.language === "nl" ? this.videos.NL.desktop : this.videos.EN.desktop;
			}
		},

		playVideo() {
			this.$refs.video.play();
			this.$refs.playknop.classList.add("hidden");
			this.$refs.pauzeknop.classList.remove("hidden");
			this.play = true;
		},

		pauseVideo() {
			this.$refs.video.pause();
			this.$refs.playknop.classList.remove("hidden");
			this.$refs.pauzeknop.classList.add("hidden");
			this.play = false;
		}

	},
	components: {
		Countdown
	},
	watch: {
		language() {
			this.getVideo();
		}
	}
}
</script>
